import { render, staticRenderFns } from "./ObjectTenancy.vue?vue&type=template&id=05b9137e&scoped=true"
import script from "./ObjectTenancy.vue?vue&type=script&lang=js"
export * from "./ObjectTenancy.vue?vue&type=script&lang=js"
import style0 from "./ObjectTenancy.vue?vue&type=style&index=0&id=05b9137e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b9137e",
  null
  
)

export default component.exports